module.exports = __webpack_public_path__ + "assets/images/albom_sm.e2d1f431.png";